import Box from "@mui/material/Box";
import { alpha } from "@mui/material/styles";
import { ReactNode } from "react";

/** Note set apart from the running help text. */
export function HelpCallout({ children }: { children: ReactNode }) {
  return (
    <Box
      sx={{
        mt: 1.5,
        mb: 1.25,
        px: 1.75,
        py: 1.25,
        borderRadius: "0 4px 4px 0",
        borderLeft: 3,
        borderColor: "primary.main",
        bgcolor: theme => alpha(theme.palette.primary.main, 0.06),
        fontSize: 13.5,
        color: "text.secondary",
      }}
    >
      {children}
    </Box>
  );
}
